
/* injects from baggage-loader */

'use strict';

import AccountSettingsSecurityController from './account.settings.security.controller';
import AccountSettingsSecurityTemplate from './account.settings.security.html';

export default class AccountSettingsSecurityComponent {
		constructor() {
				this.templateUrl = AccountSettingsSecurityTemplate;
				this.controller = AccountSettingsSecurityController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}
